/**
 * Sticky collection navigation behavior
 * Adds class when header is out of view to stick nav to top of browser
 */
(function() {
  'use strict';

  const NAV_SELECTOR = '[data-collection-nav]';
  const HEADER_SELECTOR = '.site-header, [data-site-header], header[role="banner"]';
  const STICKY_CLASS = 'collection__nav--stuck';
  
  let collectionNav = null;
  let header = null;
  let headerHeight = 0;
  let ticking = false;

  function init() {
    collectionNav = document.querySelector(NAV_SELECTOR);
    header = document.querySelector(HEADER_SELECTOR);
    
    if (!collectionNav || !header) return;

    updateHeaderHeight();
    checkPosition();
    
    // Listen for scroll events
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Update header height on resize
    window.addEventListener('resize', () => {
      updateHeaderHeight();
      checkPosition();
    });
  }

  function updateHeaderHeight() {
    if (header) {
      headerHeight = header.offsetHeight;
    }
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkPosition();
        ticking = false;
      });
      ticking = true;
    }
  }

  function checkPosition() {
    if (!collectionNav || !header) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerBottom = header.offsetTop + headerHeight;
    
    // If we've scrolled past the header
    if (scrollTop > headerBottom) {
      if (!collectionNav.classList.contains(STICKY_CLASS)) {
        collectionNav.classList.add(STICKY_CLASS);
      }
    } else {
      if (collectionNav.classList.contains(STICKY_CLASS)) {
        collectionNav.classList.remove(STICKY_CLASS);
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
